/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserLabelsIndexResponseUserLabelsInner } from './UserLabelsIndexResponseUserLabelsInner';
import {
    UserLabelsIndexResponseUserLabelsInnerFromJSON,
    UserLabelsIndexResponseUserLabelsInnerFromJSONTyped,
    UserLabelsIndexResponseUserLabelsInnerToJSON,
} from './UserLabelsIndexResponseUserLabelsInner';

/**
 * Space user
 * @export
 * @interface SpaceUserCreateResponse
 */
export interface SpaceUserCreateResponse {
    /**
     * 
     * @type {number}
     * @memberof SpaceUserCreateResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    note?: string;
    /**
     * 
     * @type {number}
     * @memberof SpaceUserCreateResponse
     */
    participant_id?: number;
    /**
     * 
     * @type {number}
     * @memberof SpaceUserCreateResponse
     */
    user_in_company_space_id: number;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    full_name: string;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    first_names: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    last_names: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    titles_before: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    titles_after: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    state: string;
    /**
     * 
     * @type {boolean}
     * @memberof SpaceUserCreateResponse
     */
    invitation: boolean;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    small_picture_url: string;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    picture_url: string;
    /**
     * 
     * @type {number}
     * @memberof SpaceUserCreateResponse
     */
    supervisor_id: number;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    job_title: string;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    birth_date: string;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    department: string;
    /**
     * 
     * @type {number}
     * @memberof SpaceUserCreateResponse
     */
    personal_id: number;
    /**
     * 
     * @type {string}
     * @memberof SpaceUserCreateResponse
     */
    login_headers: string;
    /**
     * 
     * @type {Date}
     * @memberof SpaceUserCreateResponse
     */
    last_activity_at: Date;
    /**
     * 
     * @type {number}
     * @memberof SpaceUserCreateResponse
     */
    assigned_count: number;
    /**
     * 
     * @type {number}
     * @memberof SpaceUserCreateResponse
     */
    in_progress_count: number;
    /**
     * 
     * @type {number}
     * @memberof SpaceUserCreateResponse
     */
    completed_count: number;
    /**
     * 
     * @type {number}
     * @memberof SpaceUserCreateResponse
     */
    overdue_count: number;
    /**
     * 
     * @type {number}
     * @memberof SpaceUserCreateResponse
     */
    groups_count: number;
    /**
     * 
     * @type {Array<UserLabelsIndexResponseUserLabelsInner>}
     * @memberof SpaceUserCreateResponse
     */
    user_labels?: Array<UserLabelsIndexResponseUserLabelsInner>;
}

/**
 * Check if a given object implements the SpaceUserCreateResponse interface.
 */
export function instanceOfSpaceUserCreateResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_in_company_space_id" in value;
    isInstance = isInstance && "full_name" in value;
    isInstance = isInstance && "first_names" in value;
    isInstance = isInstance && "last_names" in value;
    isInstance = isInstance && "titles_before" in value;
    isInstance = isInstance && "titles_after" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "invitation" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "small_picture_url" in value;
    isInstance = isInstance && "picture_url" in value;
    isInstance = isInstance && "supervisor_id" in value;
    isInstance = isInstance && "job_title" in value;
    isInstance = isInstance && "birth_date" in value;
    isInstance = isInstance && "department" in value;
    isInstance = isInstance && "personal_id" in value;
    isInstance = isInstance && "login_headers" in value;
    isInstance = isInstance && "last_activity_at" in value;
    isInstance = isInstance && "assigned_count" in value;
    isInstance = isInstance && "in_progress_count" in value;
    isInstance = isInstance && "completed_count" in value;
    isInstance = isInstance && "overdue_count" in value;
    isInstance = isInstance && "groups_count" in value;

    return isInstance;
}

export function SpaceUserCreateResponseFromJSON(json: any): SpaceUserCreateResponse {
    return SpaceUserCreateResponseFromJSONTyped(json, false);
}

export function SpaceUserCreateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpaceUserCreateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'participant_id': !exists(json, 'participant_id') ? undefined : json['participant_id'],
        'user_in_company_space_id': json['user_in_company_space_id'],
        'full_name': json['full_name'],
        'first_names': json['first_names'],
        'last_names': json['last_names'],
        'titles_before': json['titles_before'],
        'titles_after': json['titles_after'],
        'state': json['state'],
        'invitation': json['invitation'],
        'role': json['role'],
        'small_picture_url': json['small_picture_url'],
        'picture_url': json['picture_url'],
        'supervisor_id': json['supervisor_id'],
        'job_title': json['job_title'],
        'birth_date': json['birth_date'],
        'department': json['department'],
        'personal_id': json['personal_id'],
        'login_headers': json['login_headers'],
        'last_activity_at': (new Date(json['last_activity_at'])),
        'assigned_count': json['assigned_count'],
        'in_progress_count': json['in_progress_count'],
        'completed_count': json['completed_count'],
        'overdue_count': json['overdue_count'],
        'groups_count': json['groups_count'],
        'user_labels': !exists(json, 'user_labels') ? undefined : ((json['user_labels'] as Array<any>).map(UserLabelsIndexResponseUserLabelsInnerFromJSON)),
    };
}

export function SpaceUserCreateResponseToJSON(value?: SpaceUserCreateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'email': value.email,
        'note': value.note,
        'participant_id': value.participant_id,
        'user_in_company_space_id': value.user_in_company_space_id,
        'full_name': value.full_name,
        'first_names': value.first_names,
        'last_names': value.last_names,
        'titles_before': value.titles_before,
        'titles_after': value.titles_after,
        'state': value.state,
        'invitation': value.invitation,
        'role': value.role,
        'small_picture_url': value.small_picture_url,
        'picture_url': value.picture_url,
        'supervisor_id': value.supervisor_id,
        'job_title': value.job_title,
        'birth_date': value.birth_date,
        'department': value.department,
        'personal_id': value.personal_id,
        'login_headers': value.login_headers,
        'last_activity_at': (value.last_activity_at.toISOString()),
        'assigned_count': value.assigned_count,
        'in_progress_count': value.in_progress_count,
        'completed_count': value.completed_count,
        'overdue_count': value.overdue_count,
        'groups_count': value.groups_count,
        'user_labels': value.user_labels === undefined ? undefined : ((value.user_labels as Array<any>).map(UserLabelsIndexResponseUserLabelsInnerToJSON)),
    };
}

